export default __webpack_public_path__ + "static/media/003-curve.05546df5.png";